var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"contents"}},[_vm._t("default"),_vm._v(" "),_c('Lightbox',{attrs:{"service":_vm.lightboxService}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }